export default {
  private: {
    en: 'Private',
    sk: 'Súkromné',
    cz: 'Soukromé',
    de: 'Privatgelände',
  },
}
